<div class="p-l-5 p-r p-b-5 p-t-1">

    <ul class="overflow-y-auto custom-scrollbar"
        style="max-height: 100vh;">
        @for (item of basket?.items | orderBy : ['data.added_at'] : ['desc']; track trackByItemId($index, item); let
        last = $last; let first = $first) {
        <li [ngClass]="{'b-b':!last}">
            <minibasket-item class="w-12"
                             [noCustomOps]="true"
                             [item]="item"></minibasket-item>
        </li>
        }
    </ul>

    <coupon-form></coupon-form>
    <giftcards-form *ifNotTradeStore
                    class="block m-t-3"></giftcards-form>
    <basket-view-totals class="block"></basket-view-totals>
</div>